<template>
  <v-layout row wrap>
    <v-flex xs12 sm4>
      <v-card v-loading @mouseenter="show = !show" @mouseleave="show = !show" hover>
        <v-card-title v-if="modalitaEstesa" primary-title>
          <div>
            <transition mode="out-in">
              <div v-if="!show" class="title">Incasso</div>
              <div v-else class="title">Fiscale</div>
            </transition>
            <span v-if="!show" class="headline primary--text">
              {{ (homeCards.fiscale + homeCards.gestionale) | currency }}
            </span>
            <span v-else class="headline primary--text">{{ homeCards.fiscale | currency }}</span>
          </div>
          <transition name="slide-fade">
            <div class="gestionale" v-if="show">
              <transition>
                <div v-if="show" class="title">Gestionale</div>
              </transition>
              <span class="headline primary--text">{{ homeCards.gestionale | currency }}</span>
            </div>
          </transition>
          <v-icon class="card-expand-icon" color="accent">mdi-information</v-icon>
        </v-card-title>
        <v-card-title primary-title v-else>
          <div>
            <div class="title">Incasso</div>
            <span class="headline primary--text">{{ homeCards.fiscale | currency }}</span>
          </div>
        </v-card-title>
      </v-card>
    </v-flex>
    <v-flex xs6 sm4>
      <v-card v-loading hover>
        <v-card-title primary-title>
          <div>
            <div class="title">Conti</div>
            <span class="headline primary--text">{{ homeCards.conti }}</span>
          </div>
        </v-card-title>
      </v-card>
    </v-flex>
    <v-flex xs6 sm4>
      <v-card v-loading hover>
        <v-card-title primary-title>
          <div>
            <div class="title">Coperti</div>
            <span class="headline primary--text">{{ homeCards.coperti }}</span>
          </div>
        </v-card-title>
      </v-card>
    </v-flex>
    <v-flex xs12>
      <p class="caption">Dati a partire dall'ultima chiusura di cassa</p>
    </v-flex>
  </v-layout>
</template>

<script>
import stats from '@/mixins/stats';

export default {
  name: 'home-cards',
  mixins: [stats],
  data: () => ({
    show: false,
  }),
  methods: {
    async refresh(type = null) {
      if (type === 'SESSION' || type === 'LOCALI') {
        await this.homeCardsReload();
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.gestionale
  margin-left 20px
</style>
